module.exports = __webpack_public_path__ + "img/PhysicsEx.e4b8d75e.svg";